import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ms_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (
      err.response?.status === 401 &&
      window.location.pathname.startsWith("/admin") &&
      !window.location.pathname.startsWith("/admin/login")
    ) {
      localStorage.removeItem("ms_token");
      window.location.href = "/admin/login";
    }
    return Promise.reject(err);
  }
);

export const imgUrl = (u) => {
  if (!u) return "";
  return u.startsWith("http") ? u : `${process.env.REACT_APP_BACKEND_URL}${u}`;
};

export const scrollToId = (id) => {
  const el = document.querySelector(id);
  if (!el) return;
  // Navigation par bouton/ancre : signale un "saut" pour que la section
  // Avant/Après ne bloque jamais le trajet (voir ScrubSection.jsx).
  window.__jumpNav = true;
  window.__jumpNavY = el.getBoundingClientRect().top + window.scrollY - 70;
  clearTimeout(window.__jumpNavT);
  // Sécurité : le drapeau retombe tout seul même si l'animation est interrompue.
  window.__jumpNavT = setTimeout(() => { window.__jumpNav = false; }, 3000);
  // Si le scroll est figé par la section Avant/Après, on le libère d'abord.
  if (window.__scrubRelease) window.__scrubRelease();
  if (window.__lenis) {
    window.__lenis.scrollTo(el, {
      offset: -70,
      onComplete: () => {
        clearTimeout(window.__jumpNavT);
        window.__jumpNavT = setTimeout(() => { window.__jumpNav = false; }, 150);
      },
    });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};

export const apiError = (e, fallback = "Une erreur est survenue. Réessayez.") => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return fallback;
};
